var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.versions", [amt_admin]);

var main_tpl = require("./main.html");

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.versions", {
      url: "/versions",
      template: main_tpl,
      reloadOnSearch: false,
      data: {
        priority: 801,
        title: "Versions",
        role: "versions"
      },
      menu: {
        glyphicon: "globe"
      },
      controller: ["$scope", "$location", function($scope, $location) {}]
    });
  }
]);

export default app.name;
